import { SagaIterator } from "redux-saga";
import { call, put } from "redux-saga/effects";
import { HttpResponseTypeEnum } from "../core/enumerations/ServerRequestStatusEnum";
import { CommentRedux } from "../redux/comment-redux/CommentRedux";
import { setError } from "../redux/toaster-redux/ToasterRedux";

export function* getAllCommentsByPostIdSaga(
  api: any,
  action: any
): SagaIterator {
  try {
    const response = yield call(api.getAllCommentsByPostId, action.payload);
    if (
      response.status === HttpResponseTypeEnum.Success ||
      response.status === HttpResponseTypeEnum.userCreated
    ) {
      yield put(
        CommentRedux.actions.getAllCommentsByPostIdSuccess(response.data)
      );
    } else {
      yield put(
        CommentRedux.actions.getCommentRepliesByCommentIdFailure(response.data)
      );
    }
  } catch (error) {
    yield put(CommentRedux.actions.getAllCommentsByPostIdFailure(error));
  }
}

export function* getCommentRepliesByCommentIdRequestSaga(
  api: any,
  action: any
): SagaIterator {
  try {
    const response = yield call(
      api.getAllCommentRepliesByCommentId,
      action.payload
    );
    if (
      response.status === HttpResponseTypeEnum.Success ||
      response.status === HttpResponseTypeEnum.userCreated
    ) {
      yield put(
        CommentRedux.actions.getCommentRepliesByCommentIdSuccess(response.data)
      );
    } else {
      yield put(
        CommentRedux.actions.getCommentRepliesByCommentIdFailure(response.data)
      );
    }
  } catch (error) {
    yield put(CommentRedux.actions.getCommentRepliesByCommentIdFailure(error));
  }
}

export function* addCommentsSaga(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.addComments, action.payload);
    if (
      response.status === HttpResponseTypeEnum.Success ||
      response.status === HttpResponseTypeEnum.userCreated
    ) {
      yield put(CommentRedux.actions.addCommentsSuccess(response.data));
    } else {
      yield put(CommentRedux.actions.addCommentsFailure(response.data));
      yield put(setError(response.data));
    }
  } catch (error: any) {
    yield put(CommentRedux.actions.addCommentsFailure(error));
    yield put(setError(error));
  }
}

export function* addReplySaga(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.addReply, action.payload);
    if (
      response.status === HttpResponseTypeEnum.Success ||
      response.status === HttpResponseTypeEnum.userCreated
    ) {
      yield put(CommentRedux.actions.addReplySuccess(response.data));
    } else {
      yield put(CommentRedux.actions.addReplyFailure(response.data));
      yield put(setError(response.data));
    }
  } catch (error: any) {
    yield put(CommentRedux.actions.addReplyFailure(error));
    yield put(setError(error));
  }
}
export function* deleteCommentSaga(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.deleteComment, action.payload);
    if (
      response.status === HttpResponseTypeEnum.Success ||
      response.status === HttpResponseTypeEnum.userCreated
    ) {
      yield put(CommentRedux.actions.deleteCommentSuccess(response.data));
    } else {
      yield put(CommentRedux.actions.deleteCommentFailure(response.data));
    }
  } catch (error) {
    yield put(CommentRedux.actions.deleteCommentFailure(error));
  }
}

export function* deleteReplySaga(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.deleteReply, action.payload);
    if (
      response.status === HttpResponseTypeEnum.Success ||
      response.status === HttpResponseTypeEnum.userCreated
    ) {
      yield put(CommentRedux.actions.deleteReplySuccess(response.data));
    } else {
      yield put(CommentRedux.actions.deleteReplyFailure(response.data));
    }
  } catch (error) {
    yield put(CommentRedux.actions.deleteReplyFailure(error));
  }
}
